import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const MAT_MAN_MATCH_ACTIVITY_FRAGMENT = gql `
  fragment MatManMatchActivityFragment on MatManMatchActivity {
    rounds {
      shape
      shapeAudio {
        audio {
          ...AssetFragment
        }
      }
      answers {
        shape
        isCorrect
        selectedImage {
          image {
            ...AssetFragment
          }
        }
        unselectedImage {
          image {
            ...AssetFragment
          }
        }
      }
      completedImage {
        image {
          ...AssetFragment
        }
      }
      emptyImage {
        image {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default MAT_MAN_MATCH_ACTIVITY_FRAGMENT;
